import { useRef } from "react";

// Silent anti-bot: a hidden decoy field (bots fill it) + a form-render timestamp (time-trap).
// Zero friction for real users. Spread values() into the request body; render field() in the form.
export function useHoneypot() {
  const fts = useRef(Date.now());
  const hpRef = useRef(null);
  const values = () => ({ hp: hpRef.current?.value || "", fts: fts.current });
  const field = (
    <input
      ref={hpRef}
      type="text"
      name="company"
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      defaultValue=""
      style={{ position: "absolute", left: "-9999px", top: 0, width: 1, height: 1, opacity: 0 }}
    />
  );
  return { field, values };
}
